import NewDashboard from './NewDashboard';

export default NewDashboard;
